import { Grid, withWidth, Menu, MenuItem, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import { Spinner, SpinnerSize, Stack } from "office-ui-fabric-react";
import Logo from "../assets/landingPage/LogoBlack.svg";
import MenuIcon from "@material-ui/icons/Menu";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import PlatformImage from "../../../../../assert/images/landingpageImg_new.svg";
import { AuthActions } from "../../../../../modules/redux";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useDispatch } from "react-redux";
import { AuthState } from "../../../../../modules/redux/Auth/reducer";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import indexStyles from "./styles.module.css";

const ColorButton = styled(Button)(({ theme }) => ({
  fontFamily: "Abadi"
}));

function alertMessageHTML(severity, title, message, props, dispatch) {
  setTimeout(function () {
    props.setDisableError(true);
    dispatch(AuthActions.logout(""));
    props.setShowRequestTrialMessage(false);
  }, 60000);

  return !props.disableError ? (
    <Alert
      severity={severity}
      style={{
        backgroundColor: "#118F7D",
        opacity: 0.7,
        color: "black",
        fontSize: "12px",
        position: "fixed",
        width: "100%",
        bottom: "0",
        zIndex: "9"
      }}
      onClose={() => {
        dispatch(AuthActions.logout(""));
      }}
    >
      <AlertTitle>{title}</AlertTitle>
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </Alert>
  ) : (
    <></>
  );
}

export const useStyles = makeStyles(() => ({
  menu: {
    "& .MuiPaper-root": {
      backgroundColor: "#273041"
    }
  }
}));

const pages = ["Overview", "Capabilities", "Benefits", "Contact Us"];

function OverView(props) {
  const [value, setValue] = React.useState(0);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const MENU_ITEMS = {
    HOME: "home",
    BENEFITS: "benefits",
    OFFER: "offer",
    CONTACT: "contact"
  };

  let [width, setWidth] = React.useState(window.innerWidth);

  let updateWidthAndHeight = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", updateWidthAndHeight);
    return () => window.removeEventListener("resize", updateWidthAndHeight);
  });

  const handleChange = (data) => {
    setValue(data);
    switch (data) {
      case 0:
        props.handleMenuClick(MENU_ITEMS.HOME);
        break;
      case 1:
        props.handleMenuClick(MENU_ITEMS.OFFER);
        break;
      case 2:
        props.handleMenuClick(MENU_ITEMS.BENEFITS);
        break;
      case 3:
        props.handleMenuClick(MENU_ITEMS.CONTACT);
        break;
      default:
        props.handleMenuClick(MENU_ITEMS.HOME);
        break;
    }
  };
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const academy = (
    <Grid style={{
      position : "relative"
    }} item xs={3} sm={3} md={3}>
      <Typography
        style={{
          position: "absolute",
          left: -200,
          top: 280,
          transform: "rotate(270deg)",
          fontSize: props.width === "xs" || props.width === "sm" ? 60 : 134,
          fontWeight: 800,
          color: "#502eff",
          opacity: "0.04"
        }}
      >
        Mx HPC
      </Typography>
    </Grid>
  );

  const signup = (
    <Grid
      item
      xs={9}
      sm={9}
      md={9}
      style={{
        display : "flex",
        alignItems : "center",
        marginTop: props.width === "xs" || props.width === "sm" ? 40 : 30,
        marginLeft: props.width === "xs" || props.width === "sm" ? 0 : -25
      }}
    >
      <Grid
        container
        direction="row"
        style={{
          height:
            props.width === "xs" || props.width === "sm" ? " 550px" : "600px",
          paddingTop: props.width === "xs" || props.width === "sm" ? 12 : 0,
          paddingLeft: props.width === "xs" || props.width === "sm" ? 20 : 0
        }}
      >
        <Grid item sm={12} className={indexStyles.BannerTitle} md={12} style={{ 
          
          justifyContent: "center" 
        }}>
          <Typography
            style={{
              fontSize:
                props.width === "xs" || props.width === "sm" ? 24 : "2.3vw",
              fontWeight: 1000,
              color: "#502eff",
              lineHeight: 1,
              marginTop : props.width === "xs" || props.width === "sm" ? "0":"auto"
            }}
          >
            ManageX{" "}
            <span
              style={{
                fontSize:
                  props.width === "xs" || props.width === "sm" ? 24 : "2.3vw",
                fontWeight: 1000,
                color: "#502eff"
              }}
            >
              {" "}
              HPC
            </span>
          </Typography>
          <br />
          <Typography
            style={{
              fontWeight: 600,
              fontSize:
                props.width === "xs" || props.width === "sm" ? 16 : "1vw"
            }}
          >
            The power of{" "}
            {props.width === "xs" || props.width === "sm" ? <br /> : <></>} HPC
            made simple
          </Typography>
          <br />
          <Grid item sm={6} md={6}>
            <div style={{ paddingTop: 20 }}>
              <ColorButton
                variant="contained"
                onClick={() => {
                  props.handleMenuClick("requestTrail");
                }}
              >
                Sign Up
              </ColorButton>
            </div>
          </Grid>
          <br />
          <br />
          <br />
          {/*<Typography style={{ fontWeight: 800, fontSize: props.width === 'xs' || props.width === 'sm' ? 24 : "2vw" }}>NOW AVAILABLE:</Typography><br />*/}
          {/*<Grid container direction={ props.width === 'xs'? "column" : "row"} style={{ alignItems: props.width === 'xs' ? "flex-start" : "center" }}>*/}
          {/*    <Grid item sm={11} md={11} xs={props.width === 'xs' ? 10 : 11}>*/}
          {/*        <Typography style={{ fontWeight: 600, fontSize: props.width === 'xs' || props.width === 'sm' ? 16 : "1.3vw", paddingTop: props.width === 'xs' ? 4 : 0 }}>NIST 800-171 Compliant Environments for your research workloads</Typography>*/}
          {/*    </Grid>*/}
          {/*</Grid>*/}
        </Grid>
      </Grid>
    </Grid>
  );

  const whatIsIt = (
    <div
      style={{
        marginLeft: props.width === "xs" || props.width === "sm" ? 10 : 84,
        marginBottom: 32
      }}
    >
      <ol
        className="tick-list"
        style={{
          color: "#f1f1f1",
          fontSize: props.width === "xs" || props.width === "sm" ? 14 : "1vw"
        }}
      >
        <li>
          <span
            style={{
              fontSize:
                props.width === "xs" || props.width === "sm" ? 14 : "1vw",
              color: "#f1f1f1"
            }}
          >
            Boost your productivity across all research disciplines
          </span>
        </li>
        <li>
          <span
            style={{
              fontSize:
                props.width === "xs" || props.width === "sm" ? 14 : "1vw",
              color: "#f1f1f1"
            }}
          >
            Complex architectures deployed with a single click
          </span>
        </li>
        <li>
          <span
            style={{
              fontSize:
                props.width === "xs" || props.width === "sm" ? 14 : "1vw",
              color: "#f1f1f1"
            }}
          >
            Efficient & granular cost management with modern governance
          </span>
        </li>
        <li>
          <span
            style={{
              fontSize:
                props.width === "xs" || props.width === "sm" ? 14 : "1vw",
              color: "#f1f1f1"
            }}
          >
            Compelling research outcomes that bridge academia and cloud
          </span>
        </li>
      </ol>
    </div>
  );

  const content = (
    <Grid item xs={12} sm={12} md={12} style={{ backgroundColor: "#3e3de6" }}>
      <Grid
        container
        direction="row"
        style={{
          paddingLeft: props.width === "xs" || props.width === "sm" ? 10 : 0,
          marginTop: props.width === "xs" || props.width === "sm" ? 10 : 0
        }}
        spacing={props.width === "xs" || props.width === "sm" ? 3 : 10}
      >
        <Grid
          item
          xs={7}
          sm={7}
          md={7}
          style={{
            marginTop: props.width === "xs" || props.width === "sm" ? 20 : 0
          }}
        >
          <Stack vertical>
            <Typography
              style={{
                fontWeight: 700,
                fontSize:
                  props.width === "xs" || props.width === "sm" ? 32 : "2.3vw",
                color: "#fff",
                marginLeft:
                  props.width === "xs" || props.width === "sm" ? 10 : 84,
                marginTop:
                  props.width === "xs" || props.width === "sm" ? 32 : 110
              }}
            >
              What is it?
            </Typography>
            {props.width !== "xs" && whatIsIt}
          </Stack>
        </Grid>
        <Grid
          item
          xs={5}
          sm={5}
          md={5}
          style={{
            textAlign: "right",
            marginTop: props.width === "xs" || props.width === "sm" ? 0 : 50
          }}
        >
          {[...Array(props.width === "xs" || props.width === "sm" ? 4 : 3)].map(
            (_, j) => {
              let data = [
                ...Array(props.width === "xs" || props.width === "sm" ? 5 : 8)
              ].map((_, i) => {
                return (
                  <span
                    key={i}
                    style={{
                      margin:
                        props.width === "xs" || props.width === "sm"
                          ? 8
                          : width >= 1600
                          ? 20
                          : 15,
                      height:
                        props.width === "xs" || props.width === "sm"
                          ? 11
                          : width >= 1600
                          ? 25
                          : 21,
                      width:
                        props.width === "xs" || props.width === "sm"
                          ? 11
                          : width >= 1600
                          ? 25
                          : 21,
                      backgroundColor: "#5e5ee6",
                      borderRadius: "50%",
                      display: "inline-block"
                    }}
                  ></span>
                );
              });
              return <div key={j}>{data}</div>;
            }
          )}

          {/* <img src={OverViewBg} alt="Bg" height={props.width === 'xs' || props.width === 'sm' ? "100%" : 200} width={props.width === 'xs' || props.width === 'sm' ? "200%" : 550} />*/}
        </Grid>

        {props.width === "xs" && (
          <Grid item xs={12} sm={12} md={12}>
            {whatIsIt}
          </Grid>
        )}

        {/*<Grid item xs={12} sm={12} md={12} style={{ margin: props.width === 'xs' || props.width === 'sm' ? "0px 30px 10px 30px" : "20px 30px 64px 100px" }}>*/}
        {/*    <Grid container direction="row" justifyContent="center" style={{ color: "#fff" }} spacing={props.width === 'xs' || props.width === 'sm' ? 5 : 0 }>*/}
        {/*        <Grid item sm={12} md={3} >*/}
        {/*            <Grid container direction="row" spacing={1}>*/}
        {/*                <Grid item sm={12} md={12} >*/}
        {/*                    <Stack horizontal>*/}
        {/*                        <img src={Panel2} alt="panel" width={props.width === 'xs' ? "13%" : props.width === 'sm' ? "5%" : "8%"} />*/}
        {/*                        <Typography style={{ fontSize: props.width === 'xs' || props.width === 'sm' ? 14 : "1.3vw", marginLeft: 10, fontWeight: 500 }}>Versatile workspaces</Typography> <br />*/}
        {/*                    </Stack>*/}

        {/*                </Grid>*/}
        {/*                <Grid item sm={8} md={8} style={{ marginLeft: props.width === 'xs' || props.width === 'sm'? 40 : 30 }} >*/}

        {/*                    <Typography style={{ fontSize: props.width === 'xs' || props.width === 'sm' ? 12 : "0.8vw", color: "#f1f1f1" }}>Boost your productivity across all research disciplines</Typography>*/}
        {/*                </Grid>*/}
        {/*                <Grid item sm={3} md={3} >*/}
        {/*                </Grid>*/}
        {/*            </Grid>*/}
        {/*        </Grid>*/}
        {/*        <Grid item sm={12} md={3} >*/}
        {/*            <Grid container direction="row" spacing={1}>*/}
        {/*                <Grid item sm={12} md={12} >*/}
        {/*                    <Stack horizontal>*/}
        {/*                        <img src={Panel1} alt="panel" width={props.width === 'xs' ? "15%" : props.width === 'sm' ? "5%" : "8%"} />*/}
        {/*                        <Typography style={{ fontSize: props.width === 'xs' || props.width === 'sm' ? 14 : "1.3vw", marginLeft: 10, fontWeight: 500 }}>Automated templates</Typography> <br />*/}
        {/*                    </Stack>*/}

        {/*                </Grid>*/}
        {/*                <Grid item sm={8} md={8} style={{ marginLeft: props.width === 'xs' || props.width === 'sm' ? 40 : 30  }} >*/}

        {/*                    <Typography style={{ fontSize: props.width === 'xs' || props.width === 'sm' ? 12 : "0.8vw", color: "#f1f1f1" }}>Complex architectures deployed with a single click</Typography>*/}
        {/*                </Grid>*/}
        {/*                <Grid item sm={3} md={3} >*/}
        {/*                </Grid>*/}
        {/*            </Grid>*/}
        {/*        </Grid>*/}
        {/*        */}
        {/*        <Grid item sm={12} md={3} >*/}
        {/*            <Grid container direction="row" spacing={1}>*/}
        {/*                <Grid item sm={12} md={12} >*/}
        {/*                    <Stack horizontal>*/}
        {/*                        <img src={Panel3} alt="panel" width={props.width === 'xs' ? "12%" : props.width === 'sm' ? "5%" : "8%"} />*/}
        {/*                        <Typography style={{ fontSize: props.width === 'xs' || props.width === 'sm' ? 14 : "1.3vw", marginLeft: 10, fontWeight: 500 }}>Management hub</Typography> <br />*/}
        {/*                    </Stack>*/}

        {/*                </Grid>*/}
        {/*                <Grid item sm={8} md={8} style={{ marginLeft: props.width === 'xs' || props.width === 'sm' ? 40 : 30 }} >*/}

        {/*                    <Typography style={{ fontSize: props.width === 'xs' || props.width === 'sm' ? 12 : "0.8vw", color: "#f1f1f1" }}>Efficient & granular cost management with modern governance</Typography>*/}
        {/*                </Grid>*/}
        {/*                <Grid item sm={3} md={3} >*/}
        {/*                </Grid>*/}
        {/*            </Grid>*/}
        {/*        </Grid>*/}
        {/*        <Grid item sm={12} md={3} >*/}
        {/*            <Grid container direction="row" spacing={1}>*/}
        {/*                <Grid item sm={12} md={12} >*/}
        {/*                    <Stack horizontal>*/}
        {/*                        <img src={Panel3} alt="panel" width={props.width === 'xs' ? "12%" : props.width === 'sm' ? "5%" : "8%"} />*/}
        {/*                        <Typography style={{ fontSize: props.width === 'xs' || props.width === 'sm' ? 14 : "1.3vw", marginLeft: 10, fontWeight: 500 }}>Service concierge</Typography> <br />*/}
        {/*                    </Stack>*/}

        {/*                </Grid>*/}
        {/*                <Grid item sm={8} md={8} style={{ marginLeft: props.width === 'xs' || props.width === 'sm' ? 40 : 30 }} >*/}

        {/*                    <Typography style={{ fontSize: props.width === 'xs' || props.width === 'sm' ? 12 : "0.8vw", color: "#f1f1f1" }}>Bridge academia and cloud for compelling research outcomes</Typography>*/}
        {/*                </Grid>*/}
        {/*                <Grid item sm={3} md={3} >*/}
        {/*                </Grid>*/}
        {/*            </Grid>*/}
        {/*        </Grid>*/}
        {/*    </Grid>*/}
        {/*</Grid>*/}
      </Grid>
    </Grid>
  );

  return (
    <React.Fragment>
      {props.showRequestTrailMessage ? (
        alertMessageHTML(
          !props.loginRequestStatus ? "error" : "success",
          !props.loginRequestStatus
            ? "Sign up Error"
            : "Sign up Request Submitted Successfully",
          props.loginErrorMessage,
          props,
          dispatch
        )
      ) : (
        <div />
      )}
      {props.auth.state === AuthState.LOGIN_ERROR ? (
        alertMessageHTML(
          "error",
          "Login Error",
          props.loginErrorMessage,
          props,
          dispatch
        )
      ) : (
        <div />
      )}
      {/* navbar */}
      <AppBar position="fixed" className={indexStyles.mainMenu}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box
              href="#app-bar-with-responsive-menu"
              sx={{
                display: { xs: "none", md: "flex" }
              }}
              className={indexStyles.logo}
            >
              <img src={Logo} alt="Logo" className={indexStyles.menuLogo} />
            </Box>
            {/* Mobile menu */}
            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "flex", md: "none" },
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="default"
              >
                <MenuIcon />
              </IconButton>
              <img src={Logo} alt="Logo" height="30px" />
              {/* dropdown menu */}
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                  flexGrow: 0
                }}
              >
                {pages.map((page, index) => (
                  <MenuItem
                    key={page}
                    onClick={() => {
                      handleChange(index);
                      handleCloseNavMenu();
                    }}
                  >
                    <Typography>{page}</Typography>
                  </MenuItem>
                ))}
              </Menu>
              <div
                style={{
                  fontWeight: 800,
                  fontSize: 14,
                  color: "#6b3bf9",
                  cursor: "pointer"
                }}
                onClick={() => {
                  props.setShowRequestTrialMessage(false);
                  props.onSignIn();
                }}
              >
                {props.auth.state === props.AuthState.LOGIN_REQUEST ||
                props.auth.state === props.AuthState.SET_TOKEN ? (
                  <Spinner
                    styles={{
                      root: { marginTop: "3px", color: "#6b3bf9" }
                    }}
                    size={SpinnerSize.small}
                    label="SIGN IN...."
                    ariaLive="assertive"
                    labelPosition="right"
                  />
                ) : (
                  <Stack horizontal horizontalAlign="end">
                    {" "}
                    <ExitToAppIcon style={{ color: "#000" }} />
                  </Stack>
                )}
              </div>
            </Box>
            {/* Desktop Menu */}
            <Box
              sx={{
                marginLeft: "auto",
                display: { xs: "none", md: "flex" }
              }}
            >
              {pages.map((page, index) => (
                <ColorButton
                  key={index}
                  sx={{ my: 2, display: "block" }}
                  className={
                    value === index
                      ? indexStyles.active + " " + indexStyles.menuItems
                      : indexStyles.menuItems
                  }
                  onClick={() => {
                    handleChange(index);
                  }}
                >
                  {page}
                </ColorButton>
              ))}
              {props.auth.state === props.AuthState.LOGIN_REQUEST ||
              props.auth.state === props.AuthState.SET_TOKEN ? (
                <Spinner
                  styles={{ root: { marginTop: "3px", color: "#6b3bf9" } }}
                  size={SpinnerSize.small}
                  label="SIGN IN..."
                  ariaLive="assertive"
                  labelPosition="right"
                />
              ) : (
                <ColorButton
                  onClick={() => {
                    props.setShowRequestTrialMessage(false);
                    props.onSignIn();
                  }}
                  className={indexStyles.menuItems}
                >
                  Sign in
                </ColorButton>
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      {props.width === "xs" || props.width === "sm" ? (
        <>
          <div>
            <Grid
              container
              direction="row"
              style={{ height: "100%", justifyContent: "center" }}
            >
              {props.width !== "xs" && (
                <Grid item xs={3} sm={3} md={3} style={{ height: 550 }}>
                  <Typography
                    style={{
                      position: "absolute",
                      top: 270,
                      left: -200,
                      transform: "rotate(270deg)",
                      fontSize:
                        props.width === "xs" || props.width === "sm"
                          ? 100
                          : 134,
                      fontWeight: 800,
                      color: "#502eff",
                      opacity: "0.04"
                    }}
                  >
                    Research
                  </Typography>
                </Grid>
              )}
              {signup}
              {content}
            </Grid>
          </div>
        </>
      ) : (
        <Grid container direction="row" style={{ backgroundColor: "#fff" }}>
          <Grid
            item
            sm={12}
            md={6}
            style={{ 
              display: "flex",
              justifyContent: "center",
              height: props.width === "xl" ? "1000px" : "750px" }}
          >
            <Grid container
             style={{ 
                
                justifyContent : "center"
              }}
            direction="row">
              {academy}
              {signup}
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            ls={6}
            style={{ display: "flex", alignItems: "center" }}
          >
            {/*<SimpleImageSlider*/}
            {/*    width="50%"*/}
            {/*    height="750px"*/}
            {/*    images={images}*/}
            {/*    showBullets={true}*/}
            {/*    slideDuration={0.5}*/}
            {/*    loop={true}*/}
            {/*    autoPlay={true}*/}
            {/*    showNavs={true}*/}
            {/*/>*/}
            <div>
              <img
                src={PlatformImage}
                alt="Platform"
                width={props.width === "md" ? "52%" : "96%"}
                height="100%"
              />
            </div>
          </Grid>
          {content}
        </Grid>
      )}
    </React.Fragment>
  );
}

export default withWidth()(OverView);
